import(/* webpackMode: "eager", webpackExports: ["FunnelClient"] */ "/opt/eop-platform/apps/crewpass37/apps/web/src/app/bewerben/_components/FunnelClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/eop-platform/apps/crewpass37/node_modules/.pnpm/next@15.5.19_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/next/dist/client/app-dir/link.js");
